/**
 * The app's one global shortcut rule (SA-1306 spec §2.3): `?` opens Help & feedback. A later shortcut
 * reads the same guard, so a key typed into a field is never taken from it.
 */
export const HELP_SHORTCUT = '?'

function isEditable(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false
  if (target.isContentEditable) return true
  const tag = target.tagName
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT'
}

export function isHelpShortcut(event: KeyboardEvent): boolean {
  if (event.key !== HELP_SHORTCUT || event.defaultPrevented) return false
  if (event.ctrlKey || event.metaKey || event.altKey) return false
  return !isEditable(event.target)
}
